import React from 'react';

import { ActiveTab, CountLabel, Tab, ViewTabStyle } from './ViewTab.style';

export type TabValue<TId = string> = {
  id: TId;
  value: string;
  /**
   * Static record count shown next to the label, e.g. "Patients (312)".
   * Omit to render the tab without a count.
   */
  count?: number;
};

export default function ViewTab<TTabValue extends TabValue>({
  tabArray,
  changeTab,
  height = 35,
  selected,
}: {
  tabArray: readonly TTabValue[];
  changeTab?: (value: TTabValue) => void;
  height?: number;
  selected: TTabValue;
}) {
  const tabPosition = tabArray.findIndex((tab) => tab.id === selected.id);
  const tabWidth = 100 / tabArray.length;

  return (
    <ViewTabStyle height={height}>
      {tabArray.map((tab, index) => (
        <Tab
          active={tab.id === selected.id}
          data-testid={`tab-${index + 1}`}
          key={tab.id}
          onClick={() => changeTab?.(tab)}
          width={tabWidth}
        >
          {tab.value}
          {tab.count !== undefined && <CountLabel> ({tab.count})</CountLabel>}
        </Tab>
      ))}
      <ActiveTab position={tabPosition} width={tabWidth} />
    </ViewTabStyle>
  );
}
